import React, { Component } from 'react';
import {
  Button,
  Header,
  Icon,
  Image,
  Menu,
  Segment,
  Sidebar
} from 'semantic-ui-react';

export default class SidebarMenu extends Component {
  state = {
    visible: false
  };

  componentWillReceiveProps = nextProps => {
    if (nextProps.visible !== this.state.visible) {
      this.setState({ visible: nextProps.visible });
    }
  };

  handleSidebarHide = () => {
    console.log('hide sidebar');
    this.setState({ visible: false });
    this.props.onClose();
  };

  handlePointSelect = (point, e) => {
    this.handleSidebarHide();
    this.props.onPointSelect(point, e);
  };

  render() {
    const { visible } = this.state;
    const { data } = this.props;

    const panoramaLinks = data.maps
      .filter(point => point.is360)
      .map((point, i) => (
        <Menu.Item
          as="a"
          onClick={e => this.handlePointSelect(point, e)}
          key={`menu-item-${i}-${point.title}-360`}
        >
          {point.title}
        </Menu.Item>
      ));
    const matterportLinks = data.maps
      .filter(point => !point.is360)
      .map((point, i) => (
        <Menu.Item
          as="a"
          onClick={e => this.handlePointSelect(point, e)}
          key={`menu-item-${i}-${point.title}-mp`}
        >
          {point.title}
        </Menu.Item>
      ));
    return (
      <div>
        <Sidebar
          as={Menu}
          animation="overlay"
          direction="left"
          inverted
          vertical
          visible={visible}
          onHide={this.handleSidebarHide}
        >
          <Menu.Item
            as="div"
            style={{
              fontSize: 24,
              paddingTop: 10,
              paddingBottom: 10,
              fontWeight: 'light'
            }}
          >
            <a style={{ cursor: 'pointer' }} onClick={this.handleSidebarHide}>
              ×
            </a>
          </Menu.Item>
          <Menu.Item as={Header}>Matterport VR Tour</Menu.Item>
          {matterportLinks}
          <Menu.Item as={Header}>360 Images</Menu.Item>
          {panoramaLinks}
        </Sidebar>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SidebarMenu.js